export default {
  sessionDuration:
    '{hours} {hours, plural, one {hour} other {hours}} {minutes} {minutes, plural, one {minute} other {minutes}}',
}
